export function getMultiJobConnectedStops(mapData, selectedTour, highlightStop) {
  if (!mapData?.geo?.features || selectedTour == null || highlightStop == null) {
    return [];
  }

  const stopFeatures = mapData.geo.features.filter(
    (f) =>
      f.geometry.type === 'Point' &&
      f.properties.routeId === selectedTour &&
      f.properties.jobOrder != null &&
      !f.properties.stopLocation &&
      f.properties.jobIds,
  );

  const highlightedStop = stopFeatures.find(
    (f) => f.properties.jobOrder === highlightStop,
  );

  if (!highlightedStop || !highlightedStop.properties.jobIds?.length) {
    return [];
  }

  const highlightedJobIds = new Set(highlightedStop.properties.jobIds);

  const connectedStops = stopFeatures.filter(
    (f) =>
      f.properties.jobOrder !== highlightStop &&
      f.properties.jobIds.some((id) => highlightedJobIds.has(id)),
  );

  if (connectedStops.length === 0) {
    return [];
  }

  const allStops = [highlightedStop, ...connectedStops].sort(
    (a, b) => a.properties.jobOrder - b.properties.jobOrder,
  );

  const lines = [];
  for (let i = 0; i < allStops.length - 1; i++) {
    lines.push({
      from: allStops[i].geometry.coordinates,
      to: allStops[i + 1].geometry.coordinates,
    });
  }

  return lines;
}

export function getMultiJobConnectedJobOrders(mapData, selectedTour, highlightStop) {
  if (!mapData?.geo?.features || selectedTour == null || highlightStop == null) {
    return [];
  }

  const stopFeatures = mapData.geo.features.filter(
    (f) =>
      f.geometry.type === 'Point' &&
      f.properties.routeId === selectedTour &&
      f.properties.jobOrder != null &&
      !f.properties.stopLocation &&
      f.properties.jobIds,
  );

  const highlightedStop = stopFeatures.find(
    (f) => f.properties.jobOrder === highlightStop,
  );

  if (!highlightedStop || !highlightedStop.properties.jobIds?.length) {
    return [];
  }

  const highlightedJobIds = new Set(highlightedStop.properties.jobIds);

  const connectedStops = stopFeatures.filter(
    (f) =>
      f.properties.jobOrder !== highlightStop &&
      f.properties.jobIds.some((id) => highlightedJobIds.has(id)),
  );

  return connectedStops.map((f) => f.properties.jobOrder);
}
